/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRotate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2v8h10v12H8v-4H2V2zm8 10H10v8h10zM10 4H4v12h4v-6h2zm12-2v5.996L16 8V6l2.635-.001C17.504 5.037 15.857 4 14 4V2c2.498 0 4.606 1.329 6 2.526V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRotate as Rotate };
